
/* Import Modules */
import $ from "jquery";

// 完了ボタン 押下イベント
export const copyCompleteForm = (route: string) => {

    /* Formを複製 */
    const form = $("#schedule_form");

    /* Action定義 変更 */
    form.attr('action', route);

    /* 車輌欄 disabled解除 */
    // 車種項 有効化
    $("#select2_car_model_id").prop("disabled", false);

    // 管理部署項 有効化
    $("#select2_mgt_department_id").prop("disabled", false);

    /* Submit */
    form.submit();

}

/**
 * グローバル関数を定義
 */
(window as any).copyCompleteForm = copyCompleteForm;

